import React from "react";
import ProgressBar from "react-animated-progress-bar";
import EducationIcon from "../Icon/EducationIcon";
import ProjectsIcon from "../Icon/ProjectsIcon";

const Resume = () => {
  return (
    <div className="bg-accent pl-4">
      <div className="pt-20">
        <h2 className="text-4xl font-bold uppercase text-white border-l-4 border-primary pl-3">
          MY SKILLS
        </h2>
        <span class="text-6xl font-semibold hover:font-bold uppercase text-base-100">
          MY SKILLS
        </span>
      </div>
      <div className=" grid grid-cols-1 md:grid-cols-2 mt-20">
        <div>
          <span>
            <p className="text-1xl m-0">HTML 5</p>
            <ProgressBar
            className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="85"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
        <div>
          <span>
            <p className="text-1xl m-0">CSS 3</p>
            <ProgressBar
              className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="65"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
        <div>
          <span>
            <p className="text-1xl m-0">Javascript</p>
            <ProgressBar
              className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="50"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
        <div>
          <span>
            <p className="text-1xl m-0">MordernJs-ES6</p>
            <ProgressBar
              className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="45"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
        <div>
          <span>
            <p className="text-1xl m-0">ReactJs</p>
            <ProgressBar
              className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="50"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
        <div>
          <span>
            <p className="text-1xl m-0">NodeJs</p>
            <ProgressBar
             className="w-72"
              height="10px"
              rect
              fontColor="gray"
              percentage="30"
              rectPadding="1px"
              rectBorderRadius="20px"
              trackPathColor="transparent"
              bgColor="#333333"
              trackBorderColor="grey"
            />
          </span>
        </div>
      </div>
      {/* Resume part */}
      <div className=" pt-20">
        <h2 className="text-4xl font-bold uppercase text-white border-l-4 border-primary pl-3">
          Resume
        </h2>
        <span class="text-6xl font-semibold hover:font-bold uppercase text-base-100">
          Resume
        </span>
      </div>

      <div className="pt-20 ">
        <h2 className="text-3xl font-bold text-white">
          {" "}
          <span className="">
            <ProjectsIcon></ProjectsIcon>
          </span>{" "}
          Recent Projects
        </h2>

        <div className="pl-5 mt-5">
          <h3 className="text-2xl text-primary">
            1. Independent Service Provider law website
          </h3>
          <h3 className="text-2xl mt-2"> - Features-site</h3>
          <ul className="list-disc pl-5">
            <li>Its single independent law service provide website.</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>Users service books, appointment , this features.</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>
              <b>Technology-use</b> : React Bootstrap, React Router Dom, Toaster
              notify, Sweet Alert, firebase auth system.
            </li>
          </ul>
        </div>

        <div className="pl-5 mt-7">
          <h3 className="text-2xl text-primary">
            2. Inventory Perfume-House- (Full-Stack)
          </h3>
          <h3 className="text-2xl mt-2"> - Features-site</h3>
          <ul className="list-disc pl-5">
            <li>This Website is inventory perfume warehouse website.</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>
              Website have inventory items, user logins this product buying.
            </li>
          </ul>
          <ul className="list-disc pl-5">
            <li>
              <b>Technology-use</b> :(Client-site: React Bootstrap, React Router
              Dom, Toaster notify, Sweet Alert, )
              <br />
              (Server-site: Node Mongo db database , express Js, Firebase
              authentication , Heroku deploy)
            </li>
          </ul>
        </div>

        <div className="pl-5 mt-7">
          <h3 className="text-2xl text-primary">
            3. Car Parts Manufactures website- (Full-Stack)
          </h3>
          <h3 className="text-2xl mt-2"> - Features-site</h3>
          <ul className="list-disc pl-5">
            <li>
              Develop frontend experience html , CSS framework react- bootstrap
              , React Js.
            </li>
          </ul>
          <ul className="list-disc pl-5">
            <li>Using backend Node.js Express Js, Mongo db.</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>Implement the React router DOM to allow nested rest Api</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>Authentication using google firebase auth system</li>
          </ul>
          <ul className="list-disc pl-5">
            <li>
              Integrate Payments gateway system , with admin Panel dashboard
              management .
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-20">
        <h2 className="text-3xl font-bold text-white">
          <span className="">
            <EducationIcon></EducationIcon>
          </span>{" "}
          . Educational Qualifications
        </h2>
        <h2 className="pl-7 mt-5">B.A (hons) </h2>
        <h2 className="pl-7">Department of Philosophy - 2018- 2022 </h2>
        <h2 className="pl-7">National university of bangladesh</h2>
      </div>

      <div className="mt-20">
        <h2 className="text-3xl font-bold text-white">
          <span className="">
            <EducationIcon></EducationIcon>
          </span>{" "}
          . Courses
        </h2>

        <div className="pl-5 mt-7">
          <h3 className="text-2xl text-primary">
            1. Complete web development (Jan-Jun 2022)
          </h3>
          <h3 className="text-1xl font-bold"> - Programming hero </h3>
        </div>
        <div className="pl-5 mt-7">
          <h3 className="text-2xl text-primary">2. Web-design (2019)</h3>
          <h3 className="text-1xl font-bold">
            {" "}
            - Skills for employment investment program (SEIP)
          </h3>
        </div>
        <div className="pl-5 mt-7">
          <h3 className="text-2xl text-primary">
            3. Advanced Web-development - php, laravel (2020)
          </h3>
          <h3 className="text-1xl font-bold"> - Coders Trust Bangladesh</h3>
        </div>
      </div>

      <br />
      <br />
      <br />
    </div>
  );
};

export default Resume;
